export default __webpack_public_path__ + "static/media/smile-1.35a23b94.svg";